/*
 * Copyright (c) 2023. Legalbird eine Marke der R+S Internet Jewels GmbH
 */
import AuthorityInvoices from "../../AuthorityInvoices/AuthorityInvoices";
import PageContentContainer from "../../Container/PageContentContainer";
import PageHeadline from "../../PageHeadline/PageHeadline";
import ContentBox from "../../ContentBox/ContentBox";

const AuthorityInvoicePage = () => {
  return (
    <PageContentContainer size="tiny">
      <PageHeadline main="Rechnungen Akteneinsicht" />
      <ContentBox>
        <AuthorityInvoices />
      </ContentBox>
    </PageContentContainer>
  );
};

export default AuthorityInvoicePage;
